import { BBDTag, IconButton } from '@gravitate-js/excalibrr'
import React from 'react'

export function RequestStatusTag({ data, openImageModal }) {
  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      {data?.extra_fields?.some((field) => field.type === 'photo') && (
        <IconButton
          hoverTitle='View Images'
          onClick={(e) => {
            e.stopPropagation()
            openImageModal(data.id)
          }}
        />
      )}
      <StatusTag requestStatus={data.status} />
    </div>
  )
}

export function StatusTag({ requestStatus }) {
  switch (requestStatus) {
    case 'rejected':
      return (
        <BBDTag textTransform='capitalize' error>
          {requestStatus}
        </BBDTag>
      )
    case 'approved':
      return (
        <BBDTag textTransform='capitalize' success>
          {requestStatus}
        </BBDTag>
      )
    default:
      return <BBDTag textTransform='capitalize'>{requestStatus}</BBDTag>
  }
}
